export const UPDATE_PAGE_TEMPLATE_NAME = 'UPDATE_PAGE_TEMPLATE_NAME';
export function updatePageTemplateName(id, name) {
  return { type: UPDATE_PAGE_TEMPLATE_NAME, payload: { id, name } };
}

export const UPDATE_PAGE_TEMPLATE_USER_LABEL = 'UPDATE_PAGE_TEMPLATE_USER_LABEL';
export function updatePageTemplateUserLabel(id, userLabel) {
  return { type: UPDATE_PAGE_TEMPLATE_USER_LABEL, payload: { id, userLabel } };
}

export const CLEAR_DEFAULT_PAGES = 'CLEAR_DEFAULT_PAGES';
export function clearDefaultPages() {
  return { type: CLEAR_DEFAULT_PAGES };
}

export const ADD_DEFAULT_PAGE = 'ADD_DEFAULT_PAGE';
export function addDefaultPage(id, templateType) {
  return { type: ADD_DEFAULT_PAGE, payload: { id, templateType } };
}

export const SET_DEFAULT_PAGES = 'SET_DEFAULT_PAGE';
export function setDefaultPages(ids) {
  return { type: SET_DEFAULT_PAGES, payload: ids };
}

export const REORDER_DEFAULT_PAGE = 'REORDER_DEFAULT_PAGE';
export function reorderDefaultPage(fromIndex, toIndex) {
  return { type: REORDER_DEFAULT_PAGE, payload: { fromIndex, toIndex } };
}

export const REORDER_LIBRARY_PAGE = 'REORDER_LIBRARY_PAGE';
export function reorderLibraryPage(fromIndex, toIndex) {
  return { type: REORDER_LIBRARY_PAGE, payload: { fromIndex, toIndex } };
}

export const REMOVE_DEFAULT_PAGE = 'REMOVE_DEFAULT_PAGE';
export function removeDefaultPage(index) {
  return { type: REMOVE_DEFAULT_PAGE, payload: index };
}

export const SET_FORM_DATA = 'SET_FORM_DATA';
export function setFormData(data) {
  return { type: SET_FORM_DATA, payload: data };
}

export const CLEAR_PAGE_LIBRARY = 'CLEAR_PAGE_LIBRARY';
export function clearPageLibrary() {
  return { type: CLEAR_PAGE_LIBRARY };
}

export const ADD_LIBRARY_PAGE = 'ADD_LIBRARY_PAGE';
export function addLibraryPage(id, templateType) {
  return { type: ADD_LIBRARY_PAGE, payload: { id, templateType } };
}

export const REMOVE_LIBRARY_PAGE = 'REMOVE_LIBRARY_PAGE';
export function removeLibraryPage(id, templateType) {
  return { type: REMOVE_LIBRARY_PAGE, payload: { id, templateType } };
}

export const SET_LIBRARY_PAGES = 'SET_LIBRARY_PAGES';
export function setLibraryPages(ids) {
  return { type: SET_LIBRARY_PAGES, payload: ids };
}
